export class mdlCheckPaymentStatusRes{
    public PaymentStatus: string;
   public PolicyNo: string;
   public InsuredIDNo: string;
   public DownloadLink:string;
   public Remarks:string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckPaymentStatusRes.ts